import React from "react";
import { useTranslation } from "react-i18next";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";

import { StyledCol, StyledTable, StyledTableBody, StyledTableHead, StyledTableRow } from "../../../styles/styledTable";
import { StyledAboutOfProfit } from "../../../cashFlow/admin/profit/styledCashFlowProfit";
import { NavLink } from "react-router-dom";

const ProfitList = ({ profits }) => {
  const { t } = useTranslation("cashFlow");

  if (!profits) {
    return (
      <PageSpinner
        position="center"
        pt="20"
        pb="20"
      />
    );
  }

  if (profits.length === 0) {
    return <Alert severity="warning">{t("profit.table.emptyData")}</Alert>;
  }

  return (
    <StyledTable
      size="14"
      className="service-profit-table"
    >
      <StyledTableHead col="4" className="service-profit-table__head">
        <div>
          {t("profit.table.service")}
        </div>
        <div>
          {t("profit.table.paymentSystem")}
        </div>
        <div>
          {t("profit.table.currency")}
        </div>
        <div>
          {t("profit.table.profit")}
        </div>
      </StyledTableHead>
      <StyledTableBody>
        {profits && profits.map((value, key) => (
          <StyledTableRow
            col="4"
            key={key}
            className="service-profit-table__row"
          >
            <StyledCol data-title={t("profit.table.service")}>
              <div>
                <NavLink
                  className="default-link"
                  to={`/cash-flow?currentTab=transactions&connection.service.name=${value.name}&connection.project.user.email=${value.email}`}
                >
                  {getServiceNameWithNickname(value.name, value.nickname)}
                </NavLink>
              </div>
            </StyledCol>
            <StyledCol data-title={t("profit.table.paymentSystem")}>
              <div>
                <NavLink
                  className="default-link"
                  to={`/cash-flow?currentTab=transactions&paymentSystem.name=${value.paymentSystemName}&connection.project.user.email=${value.email}`}
                >
                  {value.paymentSystemName}
                </NavLink>
              </div>
            </StyledCol>
            <StyledCol data-title={t("profit.table.currency")}>
              <div>
                <NavLink
                  className="default-link"
                  to={`/cash-flow?currentTab=transactions&currency.asset=${value.asset}&connection.project.user.email=${value.email}`}
                >
                  {value.asset}
                </NavLink>
              </div>
            </StyledCol>
            <StyledCol data-title={t("profit.table.profit")} inline>
              <StyledAboutOfProfit color={value.profit > 0 ? "green" : value.profit < 0 ? "red" : "transparent"}>
                {value.profit} {value.asset}
              </StyledAboutOfProfit>
            </StyledCol>
          </StyledTableRow>
        ))}
      </StyledTableBody>
    </StyledTable>
  );
};

export default ProfitList;